
export default {
  allGrades: (state) => state.grades,
  gradesLoading: (state) => state.gradesLoading
}
